<div class="data-area">
    <form id="certificatesForm" appPromptUnsubmitted>
        <table class="table table-hover table-inline-edit certificate">
            <thead class="thead-light">
            <tr>
                <th>Certificate ID</th>
                <th>Customer</th>
                <th style="width: 35%;">Plantings</th>
                <th class="text-right">Number of trees purchased</th>
                <th>Show as supporter</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
                <tr certificatesRow
                    [plantingSiteId]="site.id"
                    [isEditRow]="false"
                    [customers]="customers"
                    [plantingSiteAreas]="site.areas"
                    [selectedAddCust]="selectedCustomer"
                    [misc]="misc"
                    [placeholder]="'(Autogenerated)'"
                    [newCustomer]="newCustomer"
                    (modalCustomer)="showCustomer()"
                    [discardValues$]="discardValues$"
                    [showCustomerOnSite$]="showCustomerOnSite$"
                    (onSave)="save($event)"></tr>

                <tr certificatesRow
                    *ngFor="let row of certificates"
                    [plantingSiteId]="site.id"
                    [isEditRow]="true"
                    [rowCertificate]="row"
                    [customers]="customers"
                    [plantingSiteAreas]="site.areas"
                    [misc]="misc"
                    (onEditing)="updateCertificates($event)"
                    [discardValues$]="discardValues$"
                    [showCustomerOnSite$]="showCustomerOnSite$"
                    (onDelete)="delete($event)"></tr>
            </tbody>
        </table>
    </form>
</div>
<app-confirm-delete-modal-component #confirmDeleteModal></app-confirm-delete-modal-component>
<app-create-customer-modal #createCustomerModal [countries]="countries" (onAddedCustomer)="updateCustomer($event)"></app-create-customer-modal>
